<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
        <span class="icon">
            <i class="fi fi-ss-search-alt"></i>
            {{'MixCartonSearch.Header' | translate}}
        </span>
    </h1>

    <p-card>
        <p-accordion>
            <p-accordionTab
                    header="{{ 'Common.Form.Header' | translate }}"
                    [selected]="isSearchFormOpen">
                <form [formGroup]="searchForm">

                    <div class="p-fluid formgrid grid">

                        <div class="field col-3">
                            <label>{{ 'MixCartonSearch.Search.Storer' | translate }}</label>
                            <p-multiSelect formControlName="storerList" [options]="storerOption"
                                           placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                            >
                            </p-multiSelect>

                            <div *ngIf="((submitted || searchForm.controls.storerList.touched) && searchForm?.controls?.storerList?.errors?.required )">
                                <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
                            </div>
                        </div>

                        <div class="field col-3">
                            <label>{{ 'MixCartonSearch.Search.OrgId' | translate }}</label>
                            <p-multiSelect [options]="orgIdsOptions" formControlName="orgIdList"
                                           placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                           optionLabel="legalEntityOUName"
                                           optionValue="legalEntityOUCode">
                            </p-multiSelect>
                        </div>

                        <div class="field col-3">
                            <label>{{ 'MixCartonSearch.Search.Brand' | translate }}</label>
                            <laas-multiSelect appendTo="body" formControlName="brandList" [options]="brandOptions"
                                           [filter]="true"
                                           filterBy="label"
                                           [virtualScroll]="true"
                                           [virtualScrollItemSize]="37"
                                           placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                            </laas-multiSelect>
                        </div>

                        <div class="field col-3">
                            <label>{{ 'MixCartonSearch.Search.InternalBrand' | translate }}</label>
                            <laas-multiSelect appendTo="body" formControlName="internalBrandList" [options]="internalBrandOptions"
                                           [filter]="true"
                                           filterBy="label"
                                           [virtualScroll]="true"
                                           [virtualScrollItemSize]="37"
                                           placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                            </laas-multiSelect>
                        </div>

                        <div class="field col-3">
                            <label>{{ 'MixCartonSearch.Search.Consignee' | translate }}</label>
                            <laas-customer-dropdown
                                              formControlName="consigneeKeyList"
                                              [showToggleAll]="false"
                                              [isMultiple]="true"
                                              [showLabel]="false"
                                              [divClass]="'field'">
                            </laas-customer-dropdown>
                        </div>

                        <div class="field col-3">
                            <label>{{ 'MixCartonSearch.Search.MixCartonType' | translate }}</label>
                            <p-multiSelect appendTo="body" formControlName="mixTypeList"
                                           [options]="mixTypeListOption"
                                           placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                            </p-multiSelect>
                        </div>

                        <div class="field col-3">
                            <label>{{ 'MixCartonSearch.Search.ActiveFlag' | translate }}</label>
                            <p-dropdown formControlName="activeFlag"
                                        [options]="commonOption"
                                        placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                            </p-dropdown>
                        </div>

                    </div>

                    <div>

                        <button
                                pButton
                                pRipple
                                label="{{ 'Common.Button.Search' | translate }}"
                                (click)="searchBtnClick()">
                        </button>
                        <button
                                pButton
                                pRipple
                                label="{{ 'Common.Button.Reset' | translate }}"
                                type="reset"
                                class="p-button-secondary ml-2">
                        </button>
                        <button
                                pButton
                                pRipple
                                icon="pi pi-file"
                                label="{{ 'Common.Button.Export' | translate }}"
                                class="ml-2"
                                (click)="exportBtnClick()">
                        </button>

                    </div>

                </form>
            </p-accordionTab>
        </p-accordion>
    </p-card>

    <div class="mt-2">

        <laas-data-table
            #MixCartonTable
            [selectable]="false"
            [defaultColumns]="tableColumns"
            [value]="tableValue"
            [totalRecords]="this.pageInfo.totalRecords"
            dataKey="rowId"
            (tableOnPage)="this.tablePageChange($event)"
            (tableOnSort)="this.tableSort($event)"
            [loading]="isLoading"
            [lazy]="true"
            [rows]="5"
            (setPageSize)="setPageSize($event)"
        >

            <ng-template
                    pTemplate="body"
                    let-columns="columns"
                    let-rowData
            >

                <td *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.field">

                        <ng-container *ngSwitchCase="'orgId'" class="p-fluid">
                            <div class="overflow-text">
                                {{ rowData[col.field] | optionsMapping: orgIdsOptions | replaceNullWith: '-' }}
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'brand'" class="p-fluid">
                            <div class="overflow-text">
                                {{ rowData[col.field] | optionsMapping: brandOptions | replaceNullWith: '-' }}
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchDefault class="p-fluid">
                            <ng-container [ngSwitch]="col.dataType">
                                <ng-container *ngSwitchCase="'date'">
                                    <div class="overflow-text">
                                        {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <div class="overflow-text">
                                        {{ rowData[col.field] | replaceNullWith:'-'}}
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-container>

                    </ng-container>
                </td>
            </ng-template>
        </laas-data-table>
    </div>
</div>

<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
